import _ from 'underscore'

const _findDynamicFields = (objects) => {
    return objects.filter((obj) => obj.type.startsWith('template'))
}

export const validateTemplate = (canvasObj, templateType) => {
    let dynamicFields = _findDynamicFields(canvasObj.objects)
    let requiredNames = templateType.fields.map(
        (field) => `"${field.displayType}"`
    )

    if (dynamicFields.length < templateType.fields.length) {
        return {
            isValid: false,
            reason: `There are missing dynamic fields. Required fields include: ${requiredNames.join(
                ', '
            )}. Add them from the dynamic objects under "Layers"`,
        }
    }

    let testDict = _.indexBy(dynamicFields, 'name')

    for (let i = 0; i < templateType.fields.length; i++) {
        let targetField = templateType.fields[i]
        let field = testDict[targetField.name]
        if (!field) {
            return {
                Valid: false,
                reason: `Missing dynamic field. Under "Layers", replace the text "${dynamicFields[i].name}" with "${targetField.name}"`,
            }
        }

        if (field.type !== targetField.type) {
            return {
                isValid: false,
                reason: `Field "${targetField.name}" is the wrong type. It should be (${targetField.displayType})`,
            }
        }
    }

    return { isValid: true }
}
